import { editLocation, makeChange } from "helpers/fakebackend_helper"
import React, { useState, useEffect } from "react"
import { FormGroup, Label, Input, Button } from "reactstrap"
import { useParams } from "react-router-dom"

const EditLeaseAmountForm = ({ item }) => {
    const { lot_id } = useParams()
    const [amount, setAmount] = useState("")
    const [affectedAfter, setAffectedAfter] = useState("")
    const [note, setNote] = useState("")

    useEffect(() => {
        if (item) setAmount(item.amount || "")

        const today = new Date().toISOString().split("T")[0]
        setAffectedAfter(today)
    }, [item])

    const handleSave = async () => {
        const payload = {
            location_id: lot_id,
            type: "lease_amount",
            note,
            affected_date: affectedAfter,
            what_happened: `Lease amount changed from $${item.amount} to $${amount}`,
        }

        try {
            const user = JSON.parse(localStorage.getItem("authUser"))
            const res = await makeChange(user.token, payload)
            if (res.status === "success") {
                console.log("Change recorded:", res)

                // === Update location lease amount ===
                const updatePayload = new FormData()
                updatePayload.append("lease_amount", amount)

                await editLocation(user.token, lot_id, updatePayload)

                window.location.reload()
            }
            else {
                console.error("Failed to record change:", res)
            }
        } catch (err) {
            console.error("Error saving change:", err)
        }
    }

    return (
        <div>
            <FormGroup>
                <Label>Daily Lease Amount:</Label>
                <Input
                    type="number"
                    value={amount}
                    onChange={e => setAmount(e.target.value)}
                    placeholder="Enter daily lease amount"
                />
            </FormGroup>

            <FormGroup>
                <Label>Affected After:</Label>
                <Input
                    type="date"
                    value={affectedAfter}
                    onChange={e => setAffectedAfter(e.target.value)}
                />
            </FormGroup>

            <FormGroup>
                <Label>Note:</Label>
                <Input
                    type="textarea"
                    value={note}
                    onChange={e => setNote(e.target.value)}
                    placeholder="Optional note"
                />
            </FormGroup>

            <div className="text-end">
                <Button color="primary" onClick={handleSave}>
                    Save
                </Button>
            </div>
        </div>
    )
}

export default EditLeaseAmountForm